window.addEventListener('load', function () {
  document.querySelector('#searchRefForm').addEventListener('submit', function (e) {
    e.preventDefault();
    filterResults();
  });
  function filterResults() {
    var search = document.querySelector('#searchRefInput').value;

    //add a loader for the results
    document.getElementById('results').classList.remove('visually-hidden');
    document.getElementById('results').classList.add('loading');

    //get the results

    // If the data-related-watch attribute contains the search value we want to display it. 
    // The data-related-watch attribute contains a json_encoded array of watches references.
    //We also add the class "hidden" to all the items that don't match the search.
    // We remove the class "hidden" from the items that match the search.

    document.querySelectorAll('.product-item').forEach(function (item) {
      console.log(JSON.parse(item.dataset.relatedWatch));
      if (JSON.parse(item.dataset.relatedWatch).includes(search)) {
        item.classList.remove('visually-hidden');
      } else {
        item.classList.add('visually-hidden');
      }
    });

    //If there is no result, we display the div with the class "empty-state"
    if (document.querySelectorAll('.product-item:not(.visually-hidden)').length == 0) {
      document.querySelector('.empty-state').classList.remove('visually-hidden');
      document.querySelector('.product-list').classList.add('visually-hidden');
    } else {
      document.querySelector('.empty-state').classList.add('visually-hidden');
      document.querySelector('.product-list').classList.remove('visually-hidden');
    }

    //When the results are loaded, we remove the loader
    document.getElementById('results').classList.remove('loading');
  }
});